import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import Avatar from "components/Avatar";
import classNames from "classnames";
import { Tooltip, Menu, MenuItem } from "@mui/material";
import EditIcon from "assets/icons/edite.svg?react";
import { EAppVariant } from "dto/EAppVariant";
import {
  EXTENSION_LABEL,
  PLAN_LABEL,
  formatPrice,
} from "utils/appPlans";

const MemberCard: FC<Props> = ({ member, onEdit }) => {
  const rootRef = useRef(null);
  const refWrapper = useRef(null);
  // Menu renderowane w portalu — nie jest przycinane przez overflow:hidden listy.
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  // Pakiet Premium zawiera moduły w cenie — prezentujemy je jako stały zestaw.
  const extensions =
    member.Variant === EAppVariant.Premium
      ? [...member.Extensions]
      : member.Extensions;
  const extensionsCount = extensions?.length ?? 0;

  // Zaplanowana zmiana z końcem okresu (downgrade pakietu / usunięcie modułu).
  const scheduledVariant = member.ScheduledVariant ?? member.Variant;
  const activeUntil = member.ActiveUntil
    ? new Date(member.ActiveUntil).toLocaleDateString("pl-PL")
    : null;

  return (
    <div className={styles.workerTab} ref={rootRef}>
      <div className={styles.data}>
        <div className={styles.name}>
          <Avatar className={styles.avatar} name={member.Label} size="small" />{" "}
          {member.Label}
        </div>

        <div className={styles.subscription}>{PLAN_LABEL[member.Variant]}</div>

        <div className={styles.extensions}>
          <div
            className={classNames(styles.drop, !extensionsCount && styles.empty)}
            onClick={(e) =>
              extensionsCount && setAnchorEl(e.currentTarget)
            }
          >
            +{extensionsCount}{" "}
            <FontAwesomeIcon icon={faCaretDown}></FontAwesomeIcon>
          </div>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
          >
            {extensions.map((ext) => (
              <MenuItem key={ext} disableRipple dense>
                {EXTENSION_LABEL[ext]}
              </MenuItem>
            ))}
          </Menu>
        </div>

        <div className={styles.sum}>{formatPrice(member.MonthlyCost)}</div>

        <div className={styles.more} ref={refWrapper}>
          {member.CanEdit && (
            <Tooltip title="Edytuj">
              <div>
                <EditIcon
                  onClick={() => onEdit(member)}
                  className={classNames(styles.icon)}
                />
              </div>
            </Tooltip>
          )}
        </div>
      </div>

      {activeUntil && (
        <div className={styles.scheduled}>
          <span className={styles.badge}>Aktywny do {activeUntil}</span>
          <span>
            od kolejnego okresu: {PLAN_LABEL[scheduledVariant]}
            {member.ScheduledMonthlyCost != null &&
              ` · ${formatPrice(member.ScheduledMonthlyCost)} / mies.`}
          </span>
        </div>
      )}
    </div>
  );
};

export default MemberCard;
